import { debounce } from "lodash";
import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import { ProjectItemTemplateBreadcrumbs } from "src/helpers/breadcrumbHelper";
import { SettingsProjectsSubMenu } from "src/helpers/subMenuHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as CollectionActions from "../../../actions/collection";
import * as ItemComponentTypeActions from "../../../actions/itemComponentType";
import * as NavigationActions from "../../../actions/navigation";
import * as ProjectItemTemplateActions from "../../../actions/projectItemTemplates";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    NumberFormInput,
    SelectFormInput,
    TextFormInput,
} from "../../../components/form/index";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { CollectionPage } from "../../../containers/index";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning,
} from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import * as FormHelper from "../../../helpers/formHelper";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import {
    IProjectItemTemplateReduxFormState,
    initialProjectItemTemplateState,
} from "../../../reducers/reactReduxForms/projectItemTemplate";
import { ProjectLookupsLayout } from "../../index";

import "./ProjectItemTemplatePage.scss";

interface IProjectItemTemplatePageParams {
    projectItemTemplateId: number;
}

interface IProjectItemTemplatePageProps
    extends IRouterProps<IProjectItemTemplatePageParams> {
    form: Dtos.ProjectItemTemplate & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IProjectItemTemplateReduxFormState;

    collectionFormState: Dtos.Collection & IRegistrationFormState;

    projectId: number;
    projectItemTemplateId: number;

    // From state
    projectItemTemplate: Dtos.ProjectItemTemplate;
    collection: Dtos.Collection;
    lookups: Dtos.Lookup[];

    loadingProjectItemTemplate: boolean;
    loadProjectItemTemplateSuccess: boolean;
    loadProjectItemTemplateFailure: boolean;

    savingProjectItemTemplate: boolean;
    saveProjectItemTemplateSuccess: boolean;
    saveProjectItemTemplateFailure: boolean;

    creatingProjectItemTemplate: boolean;
    createProjectItemTemplateSuccess: boolean;
    createProjectItemTemplateFailure: boolean;

    validatingProjectItemTemplate: boolean;

    validationFailures: Dtos.ResponseError[];
    permissions?: Dtos.PersonnelTmdPermissions[];
    user: Dtos.User;

    itemComponentTypes: Dtos.ItemComponentType[];
    loadingItemComponentTypes: boolean;
    loadItemComponentTypesSuccess: boolean;
    loadItemComponentTypesFailure: boolean;
    loadItemComponentTypesErrorCode: string;
}

interface IProjectItemTemplatePageActions extends IRouterActions {
    clearProjectItemTemplate: ProjectItemTemplateActions.IProjectItemTemplateClearActionCreator;
    loadProjectItemTemplate: ProjectItemTemplateActions.IProjectItemTemplateLoadByIdActionCreator;

    saveProjectItemTemplate: ProjectItemTemplateActions.IProjectItemTemplateSaveActionCreator;
    createProjectItemTemplate: ProjectItemTemplateActions.IProjectItemTemplateCreateActionCreator;
    validateProjectItemTemplate: ProjectItemTemplateActions.IProjectItemTemplateValidateActionCreator;

    loadCollection: CollectionActions.ICollectionLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

    clearItemComponentTypes: ItemComponentTypeActions.IItemComponentTypeClearActionCreator;
    loadItemComponentTypes: ItemComponentTypeActions.IItemComponentTypeLoadActionCreator;

}

type ProjectItemTemplatePageProps = IProjectItemTemplatePageProps &
    IProjectItemTemplatePageActions;

const reduxFormName: string = "reduxForms.projectItemTemplate";

class ProjectItemTemplatePage extends React.PureComponent<
    ProjectItemTemplatePageProps,
    any
> {
    hasBeenSubmitted: boolean;

    constructor(props: ProjectItemTemplatePageProps) {
        super(props);

        this.state = {
            hasBeenSubmitted: false,
        };

        this.clearProjectItemTemplate =
            this.clearProjectItemTemplate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
        this.debounceValidate = this.debounceValidate.bind(this);
    }

    componentDidMount() {
        const {
            loadProjectItemTemplate,
            projectId,
            projectItemTemplateId,
            createProjectItemTemplate,
            setBreadcrumbs,
            setDrawerItems,
            permissions,
            itemComponentTypes,
            loadingItemComponentTypes,
            loadItemComponentTypes
        } = this.props;
        

        setDrawerItems(SettingsProjectsSubMenu(permissions));
        setBreadcrumbs(ProjectItemTemplateBreadcrumbs(projectItemTemplateId));

        if (projectItemTemplateId) {
            loadProjectItemTemplate(projectItemTemplateId);
        } else if (!projectItemTemplateId) {
            createProjectItemTemplate(projectId);
        }

        if (!itemComponentTypes && !loadingItemComponentTypes) {
            loadItemComponentTypes();
        }
    }

    componentWillReceiveProps(_nextProps: ProjectItemTemplatePageProps) {}

    componentDidUpdate(prevProps: ProjectItemTemplatePageProps, _prevState) {
        const {
            projectId,
            projectItemTemplateId,
            projectItemTemplate,
            form,
            navigate,
            loadProjectItemTemplate,
            loadingProjectItemTemplate,
            loadProjectItemTemplateSuccess,
            createProjectItemTemplate,
            creatingProjectItemTemplate,
            createProjectItemTemplateSuccess,
            savingProjectItemTemplate,
            saveProjectItemTemplateSuccess,
            validationFailures,
            loadCollection,
            setBreadcrumbs,
        } = this.props;

        if (
            projectItemTemplateId &&
            prevProps.projectItemTemplateId != projectItemTemplateId
        ) {
            loadProjectItemTemplate(projectItemTemplateId);
        } else if (!projectItemTemplateId && prevProps.projectItemTemplateId) {
            createProjectItemTemplate(projectId);
        }

        if (
            !loadingProjectItemTemplate &&
            prevProps.loadingProjectItemTemplate
        ) {
            if (loadProjectItemTemplateSuccess) {
                if (projectItemTemplate?.name) {
                    setBreadcrumbs(
                        ProjectItemTemplateBreadcrumbs(
                            projectItemTemplateId,
                            projectItemTemplate.name
                        )
                    );
                }
                this.loadForm();
            }
        }
        if (form != prevProps.form) {
            this.debounceValidate();
        }

        if (!savingProjectItemTemplate && prevProps.savingProjectItemTemplate) {
            if (saveProjectItemTemplateSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate("/settings/project/itemtemplates");
                } else if (
                    !form.saveAndReturn &&
                    projectItemTemplateId &&
                    projectItemTemplateId > 0
                ) {
                    this.loadForm();
                    if (
                        form.collectionId !== undefined &&
                        form.collectionId > 0
                    ) {
                        loadCollection(form.collectionId);
                    }
                } else if (
                    !form.saveAndReturn &&
                    !projectItemTemplateId &&
                    projectItemTemplate &&
                    projectItemTemplate.id > 0
                ) {
                    navigate(
                        "/settings/project/itemtemplates/" +
                            projectItemTemplate.id
                    );
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (
            !creatingProjectItemTemplate &&
            prevProps.creatingProjectItemTemplate
        ) {
            if (createProjectItemTemplateSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUnmount() {
        const { resetForm, loadForm } = this.props;

        this.clearProjectItemTemplate();
        this.clearItemComponentTypes();
        loadForm(reduxFormName, initialProjectItemTemplateState);
        resetForm(reduxFormName);
    }

    clearProjectItemTemplate() {
        this.props.clearProjectItemTemplate();
    }

    clearItemComponentTypes() {
        this.props.clearItemComponentTypes();
    }

    showProjectItemTemplate(): boolean {
        const { loadingProjectItemTemplate, loadProjectItemTemplateSuccess } =
            this.props;

        if (!loadingProjectItemTemplate && loadProjectItemTemplateSuccess) {
            return true;
        }

        return false;
    }

    debounceValidate = debounce(async () => {
        const hasBeenSubmitted = this.state?.hasBeenSubmitted;
        const {
            form,
            validatingProjectItemTemplate,
            validateProjectItemTemplate,
            collection,
        } = this.props;

        let changes: Dtos.ProjectItemTemplate = {} as Dtos.ProjectItemTemplate;
        let collectionChanges: Dtos.Collection = {} as Dtos.Collection;

        if (form && hasBeenSubmitted && !validatingProjectItemTemplate) {
            await validateProjectItemTemplate(
                Object.assign({ ...form }, changes),
                Object.assign({ ...collection }, collectionChanges)
            );
        }
    }, 250);

    render() {
        const { loadingProjectItemTemplate, creatingProjectItemTemplate } =
            this.props;

        return (
            <ProjectLookupsLayout
                loading={
                    loadingProjectItemTemplate || creatingProjectItemTemplate
                }
                permission={Dtos.Permission.ProjectItemTemplatesView}
            >
                {this.renderContent()}
            </ProjectLookupsLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            loadingProjectItemTemplate,
            savingProjectItemTemplate,
            permissions,
            itemComponentTypes,
        } = this.props;

        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.ProjectItemTemplatesUpdate,
                Dtos.Permission.ProjectItemTemplatesCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingProjectItemTemplate ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);
        const formNew: boolean = FormHelper.isNew(formState, form);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            details: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <div className="card card-shadow">
                        <div className="form-row pt-4 pb-2 px-4">
                            <div className="col-md-12">
                                {renderFormControls(
                                    form,
                                    "projectItemTemplate",
                                    {
                                        name: {
                                            type: RegistrationComponent.RegistrationControl,
                                            inputType: TextFormInput,
                                            inputDisabled: formDisabled,
                                            groupClassName:
                                                "form-row bottom-0 border-top-0 pb-0 pt-0",
                                            labelClassName:
                                                "col-form-label col-sm-2",
                                            fieldClassName:
                                                "col-sm-10 generic-form-field mr-0 pr-0",
                                        },
                                    },
                                    lookups,
                                    validationFailures,
                                    formProperties,
                                    changeForm
                                )}
                            </div>
                        </div>
                        <div className="form-row py-2 px-4">
                            <div className="col-md-12">
                                {renderFormControls(
                                    form,
                                    "projectItemTemplate",
                                    {
                                        description: {
                                            type: RegistrationComponent.RegistrationControl,
                                            inputType: TextFormInput,
                                            inputDisabled: formDisabled,
                                            groupClassName:
                                                "form-row bottom-0 border-top-0 pb-0 pt-0",
                                            labelClassName:
                                                "col-form-label col-sm-2",
                                            fieldClassName:
                                                "col-sm-10 generic-form-field mr-0 pr-0",
                                        },
                                    },
                                    lookups,
                                    validationFailures,
                                    formProperties,
                                    changeForm
                                )}
                            </div>
                        </div>
                        <div className="form-row py-2 px-4">
                            <div className="col-md-12">
                                {renderFormControls(
                                    form,
                                    "projectItemTemplate",
                                    {
                                        trialId: {
                                            type: RegistrationComponent.RegistrationControl,
                                            inputType: SelectFormInput,
                                            inputDisabled:
                                                formDisabled || !formNew,
                                            inputProps: {
                                                options:
                                                    generateOptionsFromLookup(
                                                        findLookup(
                                                            "ProjectItemTemplate",
                                                            "TrialId",
                                                            lookups
                                                        ),
                                                        form.trialId
                                                    ),
                                            },
                                            groupClassName:
                                                "form-row bottom-0 border-top-0 pb-0 pt-0",
                                            labelClassName:
                                                "col-form-label col-sm-2",
                                            fieldClassName:
                                                "col-sm-10 generic-form-field mr-0 pr-0",
                                        },
                                    },
                                    lookups,
                                    validationFailures,
                                    formProperties,
                                    changeForm
                                )}
                            </div>
                        </div>
                        <div className="form-row py-2 px-4">
                            <div className="col-md-12">
                                {renderFormControls(
                                    form,
                                    "projectItemTemplate",
                                    {
                                        rank: {
                                            type: RegistrationComponent.RegistrationControl,
                                            inputType: NumberFormInput,
                                            inputDisabled: formDisabled,
                                            groupClassName:
                                                "form-row bottom-0 border-top-0 pb-0 pt-0",
                                            labelClassName:
                                                "col-form-label col-sm-2",
                                            fieldClassName:
                                                "col-sm-10 generic-form-field mr-0 pr-0",
                                        },
                                    },
                                    lookups,
                                    validationFailures,
                                    formProperties,
                                    changeForm
                                )}
                            </div>
                        </div>
                        <div className="form-row py-2 px-4">
                            <div className="col-md-12">
                                {renderFormControls(
                                    form,
                                    "projectItemTemplate",
                                    {
                                        projectItemTemplateCategoryId: {
                                            type: RegistrationComponent.RegistrationControl,
                                            inputType: SelectFormInput,
                                            inputDisabled: formDisabled,
                                            inputProps: {
                                                options:
                                                    generateOptionsFromLookup(
                                                        findLookup(
                                                            "ProjectItemTemplate",
                                                            "ProjectItemTemplateCategoryId",
                                                            lookups
                                                        ),
                                                        form.projectItemTemplateCategoryId
                                                    ),
                                            },
                                            groupClassName:
                                                "form-row bottom-0 border-top-0 pb-0 pt-0",
                                            labelClassName:
                                                "col-form-label col-sm-2",
                                            fieldClassName:
                                                "col-sm-10 generic-form-field mr-0 pr-0",
                                        },
                                    },
                                    lookups,
                                    validationFailures,
                                    formProperties,
                                    changeForm
                                )}
                            </div>
                        </div>
                        <div className="form-row pt-2 pb-4 px-4">
                            <div className="col-md-12">
                                {renderFormControls(
                                    form,
                                    "projectItemTemplate",
                                    {
                                        active: {
                                            type: RegistrationComponent.RegistrationControl,
                                            inputType: CheckboxFormInput,
                                            inputDisabled: formDisabled,
                                            inputProps: {
                                                label: "Active",
                                            },
                                            inputLabel: " ",
                                            groupClassName:
                                                "form-row bottom-0 border-top-0 pb-0",
                                            labelClassName:
                                                "col-form-label col-sm-2",
                                            fieldClassName:
                                                "col-sm-10 generic-form-field",
                                        },
                                    },
                                    lookups,
                                    validationFailures,
                                    formProperties,
                                    changeForm
                                )}
                            </div>
                        </div>
                    </div>
                ),
            },
        };

        return (
            <div>
                <h1>Project Item Template</h1>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => this.handleOnSubmit(val)}
                    onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
                >
                    {renderFormControls(
                        form,
                        "projectitemtemplate",
                        formComponents,
                        lookups,
                        validationFailures,
                        formProperties,
                        changeForm
                    )}
                </Form>
                <Form model={"reduxForms.collection"}>
                    {form && !loadingProjectItemTemplate && (
                        <>
                            <br />
                            <h1>Components</h1>
                            <CollectionPage
                                qaItemComponents={false}
                                itemComponentTypeId={
                                    itemComponentTypes?.find(
                                        (x) => x.value === "Project"
                                    )?.id
                                }
                                showSections={false}
                                readonly={formDisabled}
                                collectionId={form.collectionId || 0}
                            />
                        </>
                    )}
                </Form>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => this.handleOnSubmit(val)}
                    onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
                >
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={this.onCancel}
                            className="btn btn-primary mr-2"
                        >
                            Cancel{" "}
                        </button>
                    </div>
                </Form>
            </div>
        );
    }

    renderCollection() {
        const {
            form,
            formState,
            loadingProjectItemTemplate,
            savingProjectItemTemplate,
            permissions,
            itemComponentTypes,
        } = this.props;

        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.ProjectItemTemplatesUpdate,
                Dtos.Permission.ProjectItemTemplatesCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingProjectItemTemplate ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        if (form && !loadingProjectItemTemplate && itemComponentTypes) {
            return (
                <CollectionPage
                    qaItemComponents={false}
                    itemComponentTypeId={
                        itemComponentTypes?.find((x) => x.value === "Project")
                            ?.id
                    }
                    showSections={true}
                    readonly={formDisabled}
                    collectionId={form.collectionId || 0}
                />
            );
        }
    }

    renderErrorAlert(): any {
        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>;
    }

    handleOnSubmit(data: Dtos.ProjectItemTemplate) {
        const { hasBeenSubmitted } = this.state;
        const { saveProjectItemTemplate, collection } = this.props;

        if (!hasBeenSubmitted) {
            this.setState({ hasBeenSubmitted: true });
        }

        if (data) {
            let changes: Dtos.Institution = {} as Dtos.Institution;
            let collectionChanges: Dtos.Collection = {} as Dtos.Collection;
            saveProjectItemTemplate(
                Object.assign({ ...data }, changes),
                Object.assign({ ...collection }, collectionChanges)
            );
        }
    }

    handleOnSubmitFailed(_data: Dtos.ProjectItemTemplate) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onCancel() {
        const { navigate } = this.props;

        navigate("/settings/project/itemtemplates");
    }

    loadForm() {
        const { loadForm, projectItemTemplate } = this.props;

        let extraData: Dtos.ProjectItemTemplate =
            {} as Dtos.ProjectItemTemplate;

        loadForm(
            reduxFormName,
            Object.assign({ ...projectItemTemplate }, extraData)
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: ProjectItemTemplatePageProps
): IProjectItemTemplatePageProps => {
    let projectItemTemplate: Dtos.ProjectItemTemplate | undefined = !(
        state.projectItemTemplates.formData instanceof Array
    )
        ? state.projectItemTemplates.formData
        : undefined;
    let collection: Dtos.Collection | undefined = !(
        state.reduxForms.collection instanceof Array
    )
        ? state.reduxForms.collection
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];
    let itemComponentTypes =
        state.itemComponentTypes.formData instanceof Array
            ? state.itemComponentTypes.formData
            : undefined;

    return {
        match: ownProps.match,
        projectItemTemplateId:
            ownProps.match &&
            ownProps.match.params.projectItemTemplateId &&
            ownProps.match.params.projectItemTemplateId.toString() != "create"
                ? ownProps.match.params.projectItemTemplateId
                : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        projectId: state.projectSettingsPage.projectId,
        projectItemTemplate: projectItemTemplate!,
        collection: collection!,

        loadingProjectItemTemplate:
            state.projectItemTemplates.loadState &&
            state.projectItemTemplates.loadState.status == RequestState.Pending,
        loadProjectItemTemplateSuccess:
            state.projectItemTemplates.loadState &&
            state.projectItemTemplates.loadState.status == RequestState.Success,
        loadProjectItemTemplateFailure:
            state.projectItemTemplates.loadState &&
            state.projectItemTemplates.loadState.status == RequestState.Failure,

        savingProjectItemTemplate:
            state.projectItemTemplates.saveState &&
            state.projectItemTemplates.saveState.status == RequestState.Pending,
        saveProjectItemTemplateSuccess:
            state.projectItemTemplates.saveState &&
            state.projectItemTemplates.saveState.status == RequestState.Success,
        saveProjectItemTemplateFailure:
            state.projectItemTemplates.saveState &&
            state.projectItemTemplates.saveState.status == RequestState.Failure,

        creatingProjectItemTemplate:
            state.projectItemTemplates.createState &&
            state.projectItemTemplates.createState.status ==
                RequestState.Pending,
        createProjectItemTemplateSuccess:
            state.projectItemTemplates.createState &&
            state.projectItemTemplates.createState.status ==
                RequestState.Success,
        createProjectItemTemplateFailure:
            state.projectItemTemplates.createState &&
            state.projectItemTemplates.createState.status ==
                RequestState.Failure,

        validatingProjectItemTemplate:
            state.projectItemTemplates.validateState &&
            state.projectItemTemplates.validateState.status ==
                RequestState.Pending,

        user: state.user.data,
        permissions: permissions,
        lookups: state.projectItemTemplates.lookups,

        form: state.reduxForms.projectItemTemplate,
        formState: state.projectItemTemplates.formState,
        formProperties: state.projectItemTemplates.formProperties,

        collectionFormState: state.reduxForms.collection,

        reduxFormState: state.reduxForms.formState.projectItemTemplate,
        validationFailures: projectItemTemplate
            ? state.projectItemTemplates.validationFailures
            : undefined,
        itemComponentTypes: itemComponentTypes,
        loadingItemComponentTypes:
            state.itemComponentTypes.loadState &&
            state.itemComponentTypes.loadState.status == RequestState.Pending,
        loadItemComponentTypesSuccess:
            state.itemComponentTypes.loadState &&
            state.itemComponentTypes.loadState.status == RequestState.Success,
        loadItemComponentTypesFailure:
            state.itemComponentTypes.loadState &&
            state.itemComponentTypes.loadState.status == RequestState.Failure,
        loadItemComponentTypesErrorCode:
            state.itemComponentTypes.loadState.errorCode,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: ProjectItemTemplatePageProps
): IProjectItemTemplatePageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadProjectItemTemplate: bindActionCreators(
            ProjectItemTemplateActions.LoadProjectItemTemplateById,
            dispatch
        ),
        clearProjectItemTemplate: bindActionCreators(
            ProjectItemTemplateActions.Clear,
            dispatch
        ),

        loadCollection: bindActionCreators(
            CollectionActions.LoadCollectionById,
            dispatch
        ),

        saveProjectItemTemplate: bindActionCreators(
            ProjectItemTemplateActions.SaveProjectItemTemplate,
            dispatch
        ),
        createProjectItemTemplate: bindActionCreators(
            ProjectItemTemplateActions.CreateProjectItemTemplate,
            dispatch
        ),
        validateProjectItemTemplate: bindActionCreators(
            ProjectItemTemplateActions.ValidateProjectItemTemplate,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        ),
        loadItemComponentTypes: bindActionCreators(
            ItemComponentTypeActions.LoadItemComponentType,
            dispatch
        ),
        clearItemComponentTypes: bindActionCreators(
            ItemComponentTypeActions.Clear,
            dispatch
        )
    };
};

export default RouterHoc<
    IProjectItemTemplatePageParams,
    ProjectItemTemplatePageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        ProjectItemTemplatePage
    ) as unknown as ComponentType<ProjectItemTemplatePageProps>
) as ComponentType<any>;
